<template>
    <div class="">

        <div class="items-center justify-center md:hidden">
            <img class="mx-auto h-16 w-auto" :src="require('@/assets/img/logos/logo.png')"
                 alt="Brandfi logo"/>
        </div>
        <div class="my-4 text-center justify-center">
            <span class="mx-auto text-xl ">Set new password</span>
        </div>

        <div class="bg-red-100 border-l-4 border-red-500 text-red-700 p-2"
             v-if="errors.length">
            <div v-bind:key="error" v-for="error in errors">{{ error }}</div>
        </div>
        <div class="bg-green-100 border-l-4 border-green-500 text-green-700 p-2"
             v-if="successes.length">
            <div v-bind:key="msg" v-for="msg in successes">{{ msg }}</div>
        </div>
        <div class="mt-2">
            <div class="content-start">
                <div class="">
                    <label class="block text-sm ">Login ID(Email or phone)</label>
                    <input aria-label="Email or phone number" type="text" required
                           v-model="loginId"
                           class="appearance-none rounded-md relative block w-full px-3 py-2 border
                                       border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none
                                       focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                           placeholder="Email or phone number"/>
                </div>
                <div class="my-3">
                    <label class="block text-sm leading-5 ">Password</label>
                    <input aria-label="Password" name="password" type="password" required
                           v-model="password"
                           class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                           placeholder="Password"/>
                </div>
                <div class="my-3">
                    <label class="block text-sm leading-5 ">Password confirmation</label>
                    <input aria-label="Password" type="password" required
                           v-model="password_confirmation"
                           class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                           placeholder="Password confirmation"/>
                </div>
            </div>

            <div class="mt-2">
                <button type="submit" v-on:click="resetPassword"
                        class="rounded-lg px-4 md:px-5 xl:px-4 py-3 md:py-3 xl:py-3 bg-teal-500 hover:bg-teal-600 md:text-lg
                       xl:text-base text-white uppercase font-semibold leading-tight shadow-md w-full">
                    Reset password
                </button>
            </div>
            <div class="mt-3 flex text-center">

                <router-link :to="{name:'password_forgot'}"
                             class="font-medium mx-auto text-teal-600 hover:text-teal-500 focus:outline-none focus:underline transition ease-in-out duration-150">
                    Get reset link
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import Utils from "@/services/Utils";

    export default {
        name: 'ResetPassword',
        props: {
            reset_token: String
        },
        data() {
            return {
                loading: false,
                errors: [],
                successes: [],
                loginId: null,
                password: null,
                password_confirmation: null
            }
        },
        methods: {
            resetPassword: function () {
                this.loading = true;
                this.errors = [];
                this.successes = [];
                if (this.loginId == null || this.loginId === '')
                    this.errors.push("Email or phone number field is required.");
                if (this.password == null || this.password === '')
                    this.errors.push("Password field is required.");
                if (this.password_confirmation == null || this.password_confirmation === '')
                    this.errors.push("Confirmation password field is required.");
                if (this.errors.length > 0) {
                    this.loading = false;
                    return;
                }

                /**
                 *
                 this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/auth/password/reset', {
                    login_id: this.loginId,
                    reset_token: this.reset_token,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                 */

                this.axios.post(process.env.VUE_APP_SERVER_URL + '/api/v1/auth/password/reset', {
                    login_id: this.loginId,
                    reset_token: this.reset_token,
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                }).then((result) => {
                    this.successes.push(result.data.data);
                    this.successes.push("Redirecting you to login page now...");
                    setTimeout(() => {
                        this.$router.push("/login");
                    }, 3000);
                }).catch((error) => {
                    if (error.response != null) {
                        if (error.response.status === 422)
                            this.errors = Utils.processError(error.response.data);
                        else if (error.response.status === 401)
                            this.errors.push(error.response.data.error.message);
                    } else
                        this.errors.push("An error occurred while connecting to server")
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
